import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

const getClientAndTagsGQL = clientId => {
  const query = `
    query ($clientId: ID!){
        clients(clientId: $clientId){
           nodes{
                name
                status
                logo
                code
                tags{
                    id
                    value
                    type
                    tagLinkId
                    }
           }
        }
       getTags(type: CLIENT){
            edges {
                 node {
                    id
                    value
                    type
                 }
            }
       }
    }
  `
  const params = { clientId }
  return callAuthorizedGraphQLEndpoint(query, params)
}

export { getClientAndTagsGQL }



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientEdit/gql.js